<ul class="breadcrumb">
  <li><a [routerLink]="['/home']"><span class="color-soft-grey-axial">ESTÁS EN </span>Inicio</a></li>
  <li><i class="pi pi-angle-right"></i></li>
  <li><a [routerLink]="['/configuration/entities']">Configuración</a></li>
  <li><i class="pi pi-angle-right"></i></li>
  <li><a [routerLink]="['/configuration/entities']">Entidades</a></li>
</ul>
<div class="p-grid p-grid-nogutter">
    <div class="p-col">
        <router-outlet></router-outlet>
        <p-card styleClass="p-card-content-fit">
            <ng-template pTemplate="header">
                <div class="p-card-title">
                    Entidades
                    <div class="p-card-title-actions">
                    </div>
                </div>
            </ng-template>
            <p-table #grid [value]="entities" [lazy]="true" (onLazyLoad)="loadData($event)" [loading]="loading"
                [paginator]="true" [rows]="10" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
                currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
                [rowsPerPageOptions]="[5,10,25,50]"  paginatorDropdownAppendTo="body">
                <ng-template pTemplate="header">
                  <tr>
                    <th pSortableColumn="name">Nombre</th>
                    <th pSortableColumn="name_plural">Nombre plural</th>
                    <th pSortableColumn="for_reports">Para informes</th>
                    <th width="100"></th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-entity>
                  <tr (dblclick)="edit(entity)">
                    <td>
                      {{entity.name}}
                    </td>
                    <td>{{entity.name_plural}}</td>
                    <td>{{entity.for_reports?"Sí":"No"}}</td>
                    <td class="grid-actions">
                      <a (click)="edit(entity)" *ngIf="access_entities_fields">
                        <fa-icon [icon]="['far', 'edit']"></fa-icon>
                      </a>
                    </td>
                  </tr>
                </ng-template>
            </p-table>
        </p-card>
    </div>
</div>
